import { Component, OnInit, Output, EventEmitter } from '@angular/core'
import { Input } from '@angular/core'

import { Task, UserTask, TaskCompletionStatus } from '@mprep/shared/data/models'
import { UserTaskService } from '@mprep/shared/data/services'

import {
  MessagingService
} from '../..'

@Component({
  selector: 'mp-task-completion-status',
  templateUrl: './task-completion-status.html',
  styleUrls: ['./task-completion-status.scss']
})
export class TaskCompletionStatusComponent implements OnInit {

  private static STATE_CSS_ICONS: { [key: string]: string } = {
    // lowercase TaskCompletionStatus : css classes
    complete: 'glyphicon-ok',
    incomplete: 'glyphicon-ok',
    skip: 'icon-skip',
    loading: 'glyphicon-check'
  }

  @Input() public userTask: UserTask
  @Input() public isSubtask: boolean
  @Input() public theme: string

  @Output() public completionStatusChanged: EventEmitter<string> = new EventEmitter<string>()

  public availableTaskCompletionStatuses: string[]
  public allTaskCompletionStatuses: string[] = Object.keys(TaskCompletionStatus)
    .filter((v) => {
      return isNaN(+v)
        && v !== TaskCompletionStatus[TaskCompletionStatus.Incomplete]
        && v !== TaskCompletionStatus[TaskCompletionStatus.Complete]}
    )

  constructor(
    private _userTaskService: UserTaskService,
    private _messagingService: MessagingService
  ) { }

  public ngOnInit() {
    this.theme = typeof this.theme === 'string' && this.theme.endsWith('-theme') ? `${this.theme}` : ''
    if (this.userTask.task.optional) {
      this.allTaskCompletionStatuses = this.allTaskCompletionStatuses.filter( (status) => {
        return status !== TaskCompletionStatus[TaskCompletionStatus.Skip]
      })
    }

    this.determineAvailableTaskCompletionStatuses()
  }

  public toggleComplete(emit: boolean = true) {
    if (!this.userTask) {
      return
    }

    this.setCompletionStatus(this.userTask.completionStatus !== TaskCompletionStatus[TaskCompletionStatus.Complete]
                             ? TaskCompletionStatus[TaskCompletionStatus.Complete]
                             : TaskCompletionStatus[TaskCompletionStatus.Incomplete])
  }

  public toggleSkip(emit: boolean = true) {
    if (!this.userTask) {
      return
    }
    this.setCompletionStatus(this.userTask.completionStatus !== TaskCompletionStatus[TaskCompletionStatus.Skip]
                             ? TaskCompletionStatus[TaskCompletionStatus.Skip]
                             : TaskCompletionStatus[TaskCompletionStatus.Incomplete])
  }

  public toggleStatus(emit: boolean = true) {
    if (!this.userTask) {
      return
    }
    this.setCompletionStatus(this.getNextStatus(this.userTask.completionStatus))
  }

  public setCompletionStatus(status: string, emit: boolean = true) {
    let statusToSet = this.userTask.completionStatus === status
      ? TaskCompletionStatus[TaskCompletionStatus.Incomplete] : status
    this.userTask.setCompletionStatus(statusToSet)
    this.saveUserTask(emit)
  }

  public cssIconClass(userTask: UserTask) {
    let completionStatus = userTask ? userTask.completionStatus : 'loading'
    return this.cssIcon(completionStatus)
  }

  public cssIcon(completionStatus: string) {
    let status = TaskCompletionStatus[TaskCompletionStatus[completionStatus]]
    if (!status) {
      status = TaskCompletionStatus[TaskCompletionStatus.Incomplete]
    }
    return TaskCompletionStatusComponent.STATE_CSS_ICONS[status.toLowerCase()]
  }

  private saveUserTask(emit: boolean = true) {
    this._userTaskService.save(this.userTask).subscribe()
    this.determineAvailableTaskCompletionStatuses()
    if (emit) {
      this.completionStatusChanged.emit(this.userTask.completionStatus)
    }
  }

  private determineAvailableTaskCompletionStatuses() {
    this.availableTaskCompletionStatuses = this.allTaskCompletionStatuses.filter((status) => {
      return (!this.userTask || status !== this.userTask.completionStatus)
    })
  }

  private getNextStatus(completionStatus: string): any {
    switch (completionStatus) {
      case TaskCompletionStatus[TaskCompletionStatus.Incomplete]:
        return TaskCompletionStatus[TaskCompletionStatus.Complete]
      case TaskCompletionStatus[TaskCompletionStatus.Complete]:
        return TaskCompletionStatus[TaskCompletionStatus.Skip]
      case TaskCompletionStatus[TaskCompletionStatus.Skip]:
        return TaskCompletionStatus[TaskCompletionStatus.Incomplete]
      default:
        return ''
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/task-completion-status/task-completion-status.component.ts